import React, { Component } from 'react';
import styled from 'styled-components';
import Segment from 'segment-js';
import anime from 'animejs';
import * as vars from '../../styles/vars';

export default class Loading extends Component {
  constructor() {
    super();

    this.shadow = React.createRef();
    this.path = React.createRef();
    this.wrapper = React.createRef();
    this.spinner = React.createRef();
    this.introStarted = false;
  }

  componentDidMount() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.startIntro();
      this.props.handleLoader();
      return;
    }

    this.setUpLoader();
  }

  handleLoaded = () => {
    this.startIntro();

    anime.set(this.spinner.current, {
      transformOrigin: '50% 50%',
    });

    anime({
      targets: this.spinner.current,
      opacity: 0,
      scale: 0.9,
      duration: 300,
      easing: 'easeInOutQuad',
      complete: this.props.handleLoader,
    });
  };

  startIntro = () => {
    if (this.introStarted) return;

    this.introStarted = true;
    this.props.handleIntroReady();
  };

  setUpLoader = () => {
    this.segment = new Segment(this.path.current, 0, 0);

    anime({
      targets: this.spinner.current,
      opacity: [0, 1],
      scale: [0.9, 1],
      duration: 300,
      easing: 'easeInOutQuad',
      complete: () => this.loaderCircleAnim.play(),
    });

    this.loaderCircleAnim = anime({
      targets: this.path.current,
      autoplay: false,
      keyframes: [
        {
          strokeDasharray: this.segment.strokeDasharray(0, '100%'),
          duration: 1200,
          stroke: vars.colors.brand,
        },
      ],
      easing: 'easeInOutQuad',
      loop: false,
      update: animation => {
        if (animation.progress >= 50) this.startIntro();
      },
      complete: this.handleLoaded,
    });
  };

  render() {
    return (
      <Wrapper ref={this.wrapper} role="status" aria-label="Loading">
        <Spinner ref={this.spinner}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
            <path
              stroke="#DDD"
              strokeWidth="4"
              d="M2,30a28,28 0 1,0 56,0a28,28 0 1,0 -56,0"
              fill="none"
              fillRule="evenodd"
              ref={this.shadow}
            />
            <path
              stroke="transparent"
              strokeWidth="4"
              d="M2,30a28,28 0 1,0 56,0a28,28 0 1,0 -56,0"
              fill="none"
              fillRule="evenodd"
              ref={this.path}
            />
          </svg>
        </Spinner>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
`;

const Spinner = styled.div`
  width: 40px;
  line-height: 0;
  opacity: 0;

  svg {
    width: 100%;
    position: relative;
    transform: rotate(270deg) scaleX(-1);
  }
`;
